export default "__VITE_ASSET__BP8MmqvT__"